import React from 'react';

/**
 * Loading rows (.ink-skel): grey bars where a section's rows will be, shown
 * until its data arrives so an empty state never flashes first.
 */
export function InkSkeleton({
  rows = 3,
  label = 'Loading',
  style,
}: {
  rows?: number;
  label?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div className="ink-skel" role="status" aria-label={label} aria-busy="true" style={style}>
      {Array.from({ length: rows }, (_, i) => (
        <div className="ink-skel-row" key={i}>
          <span
            className="ink-skel-bar"
            data-size="lg"
            style={{ width: `${72 - (i % 3) * 14}%` }}
          />
          <span className="ink-skel-bar" style={{ width: `${44 - (i % 2) * 12}%` }} />
        </div>
      ))}
    </div>
  );
}
